import React from "react";
import { Link } from "react-router-dom";
import {
    Collapse,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
} from "@mui/material";

import { ThemeProvider } from "@mui/styles";

import ThisTheme from "../../../themes/RMSTheme";

import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import AssignmentIcon from "@mui/icons-material/Assignment";
import PersonIcon from "@mui/icons-material/Person";
import DashboardIcon from "@mui/icons-material/Dashboard";

function RMSMenu() {
    const [open, setOpen] = React.useState(false);
    const handleClick = () => {
        setOpen(!open);
    };

    const menuItems = [
        {
            path: "/rms/",
            label: "Dashboard",
            icon: (
                <DashboardIcon sx={{ color: ThisTheme.palette.primary.main }} />
            ),
        },
        {
            path: "/rms/appraisals",
            label: "Appraisals",
            icon: (
                <AssignmentIcon
                    sx={{ color: ThisTheme.palette.primary.main }}
                />
            ),
        },
        {
            path: "/rms/appraisees",
            label: "Appraisees",
            icon: <PersonIcon sx={{ color: ThisTheme.palette.primary.main }} />,
        },
    ];

    return (
        <ThemeProvider theme={ThisTheme}>
            <List
                component="nav"
                className="menu-list"
                aria-label="Appraisal menu"
                data-cy="menu_rms"
            >
                <ListItem
                    component="div"
                    onClick={handleClick}
                    aria-expanded={open}
                    disablePadding
                >
                    <ListItemButton>
                        <ListItemIcon>
                            <AssignmentOutlinedIcon
                                sx={{ color: ThisTheme.palette.primary.main }}
                            />
                        </ListItemIcon>
                        <ListItemText primary="Appraisal" />
                        {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    </ListItemButton>
                </ListItem>
                <Collapse in={open} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                        {menuItems.map(({ path, icon, label }) => (
                            <ListItem
                                key={path}
                                component={Link}
                                to={path}
                                disablePadding
                            >
                                <ListItemButton className="nested">
                                    <ListItemIcon>{icon}</ListItemIcon>
                                    <ListItemText>{label}</ListItemText>
                                </ListItemButton>
                            </ListItem>
                        ))}
                    </List>
                </Collapse>
            </List>
        </ThemeProvider>
    );
}

export default RMSMenu;
